import {
  CircleCheck,
  Info,
  LoaderCircle,
  OctagonX,
  TriangleAlert
} from 'lucide-react'
import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

export function Toaster({ ...props }: ToasterProps) {
  return (
    <Sonner
      theme="light"
      position="top-right"
      closeButton
      duration={4500}
      className="toaster group"
      style={
        {
          fontFamily: 'Inter, system-ui, sans-serif'
        } as React.CSSProperties
      }
      icons={{
        success: <CircleCheck className="h-5 w-5 text-primary" />,
        info: <Info className="h-5 w-5 text-[#5F8CFA]" />,
        warning: <TriangleAlert className="h-5 w-5 text-peach" />,
        error: <OctagonX className="h-5 w-5 text-destructive" />,
        loading: <LoaderCircle className="h-5 w-5 animate-spin text-primary" />
      }}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-white group-[.toaster]:text-ink group-[.toaster]:border group-[.toaster]:border-ink/10 group-[.toaster]:rounded-2xl group-[.toaster]:shadow-[0_18px_44px_rgba(4,33,37,0.12)] group-[.toaster]:gap-3',
          title: 'group-[.toast]:font-sans group-[.toast]:font-semibold',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton:
            'group-[.toast]:bg-primary group-[.toast]:text-white group-[.toast]:rounded-full',
          cancelButton:
            'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground group-[.toast]:rounded-full',
          closeButton:
            'group-[.toast]:border-ink/10 group-[.toast]:text-muted-foreground'
        }
      }}
      {...props}
    />
  )
}
